<h1>{{ "Rediger avtale" | translate }}</h1>

<div class="gjeldende-kontaktperson">
  <span class="etikett">{{ "Kontaktperson:" | translate }}</span>
  <span class="navn">{{ avtale().kontaktperson.navnEllerEpost }}</span>
  <span class="epost">({{ avtale().kontaktperson.epost }})</span>
</div>

@if (oppdatert()) {
  <inline-melding type="info" class="e2e-oppdatert-melding">
    {{ "Avtale oppdatert." | translate }}
  </inline-melding>
}

<div class="avtalenavn">
  <mat-form-field>
    <mat-label>{{ "Avtalenavn" | translate }}</mat-label>
    <input matInput [formControl]="avtalenavn" class="e2e-avtalenavn"/>
  </mat-form-field>
</div>

<div class="søk">
  <mat-form-field>
    <mat-label>{{ "Søk etter ny kontaktperson" | translate }}</mat-label>
    <input matInput
           [formControl]="sokeTekst"
           [matAutocomplete]="brukerListe"
           placeholder="{{ 'Navn eller e-post' | translate }}"
           class="e2e-søk-kontaktperson"/>
    <mat-autocomplete #brukerListe="matAutocomplete"
                      [displayWith]="visNavn"
                      (optionSelected)="brukerValgt($event.option.value)">
      @for (bruker of filtrerteBrukere(); track bruker.id) {
        <mat-option [value]="bruker">
          <span class="bruker-navn">{{ bruker.navnEllerEpost }}</span>
          <span class="bruker-epost"> — {{ bruker.epost }}</span>
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
</div>

@if (valgtBruker()) {
  <div class="valgt-bruker">
    <div class="bruker-info">
      <h2 class>{{ 'Ny kontaktperson' | translate }}</h2>
      <div class="navn">{{ valgtBruker()!.navnEllerEpost }}</div>
      <div class="epost">{{ valgtBruker()!.epost }}</div>
      @if (valgtBruker()!.mobilnummer) {
        <div class="mobil">{{ valgtBruker()!.mobilnummer }}</div>
      }
    </div>
  </div>
}

<div class="knapp">
  <button mat-raised-button color="primary"
          (click)="lagreKontaktperson()"
          [disabled]="lagrer() || avtalenavn.invalid"
          class="e2e-velg-kontaktperson">
    {{ "Lagre" | translate }}
  </button>
</div>
